/*
 *  -----------------------------------------------------------------------
 *    <copyright file="report-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { useTranslation } from 'hooks';
import { ReportSignatoryFields } from 'queries/generated/fragments.generated';
import ExpandableGrid from 'views/components/core/expandable/grid';

const ReportGrid = ({
    signatoriesData,
    height,
}: {
    signatoriesData: ReportSignatoryFields[];
    height: number | string;
}) => {
    const { t } = useTranslation();

    return (
        <div style={{ height, overflowY: 'initial' }}>
            <ExpandableGrid
                customKey="report-grid-in-popup"
                id="signatoryGrid"
                items={signatoriesData}
                showPager={false}
                reorderable={false}
                pageable={false}
                resizable={false}
                addScroll={false}
                groupable={false}
                showFirstColumn={false}
                scrollable="scrollable"
                hideColumnMenu
                hideClearFilter
                columns={[
                    {
                        label: t('role'),
                        id: 'signatory-role',
                        field: 'role',
                        minWidth: 140,
                    },
                    {
                        field: 'name',
                        id: 'signatory-name',
                        label: t('name'),
                        minWidth: 180,
                    },
                    {
                        field: 'title',
                        id: 'signatory-job-title',
                        label: t('reports:jobTitle'),
                        minWidth: 180,
                    },
                ]}
            />
        </div>
    );
};

export default ReportGrid;
